import styled from 'styled-components';

interface props {
	webConfig?: {
		dir: string,
		fontFamily: string,
	},
	isLoading?: boolean,
	disabled?: boolean,
	onClick?: any,
	className?: string,
	children: React.ReactNode,
	type?: string
}

export const Wrapper = styled.button<props>`
	box-shadow: none !important;
	border: none;
	word-wrap: break-word !important;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	cursor: pointer;
	display: flex !important;
	justify-content: center !important;
	align-items: center !important;
	flex-direction: column;
	word-wrap: keep-all;
	background-color:rgba(41, 188, 171, 1);
	border-radius: 8px;
	color: white;
	font-size: 15px;
	font-weight: 700;
	font-family: Samim;
	height: 48px;
	line-height: 48px;
	direction: ${p => p.webConfig?.dir} !important;
	font-family: ${p => p.webConfig?.fontFamily} !important;
	@media (max-width: 600px) {
		font-size: 14px;
		height: 50px;
		line-height: 50px;
	}
	${p => p.disabled && `
		cursor: not-allowed;
		background-color: #B2B1B3 !important;
		border: none !important;
	`}

	${p => p.isLoading && `
		opacity: 0.8;
		cursor: not-allowed;
		.content {
			visibility: hidden;
		}
	`};

	.content {
		pointer-events: none;
		text-align: center !important;
		display: flex !important;
		justify-content: center !important;
		align-items: center !important;
		flex-direction: row;
		width: 100% !important;
	}
	.loading {
		pointer-events: none;
		text-align: center !important;
		display: flex !important;
		justify-content: center !important;
		align-items: center !important;
		flex-direction: column !important;
		width: 100%;
		margin-top: 48px;
	}
`;